import React from "react";

const CrossIcon = ({
  className = "w-5 h-5",
  onClick,
  fill = "currentColor",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M5.32293 3.39855C4.79153 2.86715 3.92996 2.86715 3.39855 3.39855C2.86715 3.92996 2.86715 4.79153 3.39855 5.32293L10.0756 12L3.39855 18.6771C2.86715 19.2085 2.86715 20.07 3.39855 20.6014C3.92996 21.1329 4.79153 21.1329 5.32293 20.6014L12 13.9244L18.6771 20.6014C19.2085 21.1329 20.07 21.1329 20.6014 20.6014C21.1329 20.07 21.1329 19.2085 20.6014 18.6771L13.9244 12L20.6014 5.32293C21.1329 4.79153 21.1329 3.92996 20.6014 3.39855C20.07 2.86715 19.2085 2.86715 18.6771 3.39855L12 10.0756L5.32293 3.39855Z"
        fill={fill}
      />
    </svg>
  );
};

export default CrossIcon;
